import React, { useState, useEffect } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import {
  AiOutlineDashboard,
  AiOutlineUser,
  AiOutlineFlag,
  AiOutlineDollar,
  AiFillAccountBook
} from "react-icons/ai";
import { AiOutlineNotification } from "react-icons/ai";
import { AiOutlineMenu } from "react-icons/ai";
import { Link } from 'react-router-dom';
import { logout } from './../features/auth/authSlice';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Outlet } from "react-router-dom";
import { IoIosSettings } from "react-icons/io";

import { Layout, Menu, theme } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from 'react-redux';
const { Header, Sider, Content } = Layout;

const MainLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const { token: { colorBgContainer }, } = theme.useToken();

  const isLogin = useSelector((state) => state.auth.isLogin);
  const user = useSelector((state) => state.auth.user);

  const handleSignout = (event) => {
    event.preventDefault();
    dispatch(logout());
  };

  useEffect(() => {
    if (!isLogin) {
      navigate("/");
    }
  }, [isLogin, navigate]);


  return (
    <Layout/* onContextMenu={(e) => e.preventDefault()} */>

      <Sider trigger={null} collapsible collapsed={collapsed} style={{ background: "#179296" }}>
        <div className="logo">
          <h2 className="text-white fs-5 text-center py-3 mb-0">
            <span className="sm-logo" style={{ color: "black" }}>Collide</span>
            <span className="lg-logo">
              <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Login" style={{width: 70, height: 50, marginTop: "-10px"}} />
            </span>
          </h2>
        </div>
        <Menu
          style={{ background: "#179296" }}
          theme="light"
          mode="inline"
          defaultSelectedKeys={[""]}
          onClick={({ key }) => {
            if (key === "signout") {
            } else {
              navigate(key);
            }
          }}
          items={[
            {
              key: "",
              icon: <AiOutlineDashboard className="fs-4" />,
              label: "Dashboard",
            },
            {
              key: "customers",
              icon: <AiOutlineUser className="fs-4" />,
              label: "Users",
            },
            // {
            //   key: "subscription",
            //   icon: <AiOutlineDollar className="fs-4" />,
            //   label: "Subscription Plans",
            // },
            {
              key: "setting",
              icon: <IoIosSettings className="fs-4" />,
              label: "Setting",
            },
            {
              key: "Catalog",
              icon: <AiOutlineFlag className="fs-4" />,
              label: "Report",
              children: [
                {
                  key: "report-user",
                  icon: <AiOutlineUser className="fs-4" />,
                  label: "Reported Profile",
                },
              ]
            },
            {
              key: "Payments",
              icon: <AiOutlineDollar className="fs-4" />,
              label: "Subscription",
              children: [
                {
                  key: "subscription",
                  icon: <AiOutlineDollar className="fs-4" />,
                  label: "Packages",
                },
                {
                  key: "user-subscriptions",
                  icon: <AiFillAccountBook className="fs-4" />,
                  label: "Subscriptions",
                },
                {
                  key: "user-payments",
                  icon: <AiFillAccountBook className="fs-4" />,
                  label: "User Payments",
                },
                {
                  key: "subscription-logs",
                  icon: <AiFillAccountBook className="fs-4" />,
                  label: "Logs",
                },
              ]
            },
            {
              key: "diamond-user",
              icon: <AiOutlineUser className="fs-4" />,
              label: "Discover Section",
            },
            {
              key: "send-notification",
              icon: <AiOutlineNotification className="fs-4" />,
              label: "Notification",
            },
            {
              key: "notification-log",
              icon: <AiOutlineMenu className="fs-4" />,
              label: "Notification Logs",
            },
            {
              key: "chat",
              icon: <AiFillAccountBook className="fs-4" />,
              label: "Chat",
            },
          ]}
        />
      </Sider>

      <Layout className="site-layout">
        <Header
          className="d-flex justify-content-between ps-1 pe-5"
          style={{
            padding: 0,
            background: colorBgContainer,
          }}
        >
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: () => setCollapsed(!collapsed),
            }
          )}
          <div className="d-flex gap-4 align-items-center">
            {/* <div className="position-relative">
              <IoIosNotifications className="fs-4" />
              <span className="badge bg-warning rounded-circle p-1 position-absolute">
                3
              </span>
            </div> */}

            <div className="d-flex gap-3 align-items-center dropdown">
              <div>
                {user?.profile_pic_url && (
                  <>
                    <img
                      width={32}
                      height={32}
                      src={user.profile_pic_url}
                      alt=""
                    />
                  </>
                )}
              </div>
              <div
                role="button"
                id="dropdownMenuLink"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {user?.first_name && (
                  <>
                    <h5 className="mb-0">{user.first_name}</h5>
                  </>
                )}
                {user?.last_name && (
                  <>
                    < p className="mb-0">{user.email}</p>
                  </>
                )}
              </div>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <li>
                  {/* <Link
                    className="dropdown-item py-1 mb-1"
                    style={{ height: "auto", lineHeight: "20px" }}
                    to="/"
                  >
                    View Profile
                  </Link> */}
                </li>
                <li>
                  <Link
                    className="dropdown-item py-1 mb-1"
                    style={{ height: "auto", lineHeight: "20px" }}
                    to="#"
                    onClick={handleSignout}
                  >
                    Signout
                  </Link>
                </li>
              </div>
            </div>
          </div>
        </Header>
        {/* <MatchNotifier userId={user.id} /> */}

        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
          }}
        >
          <ToastContainer
            position="top-right"
            autoClose={250}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            theme="light"
          />
          <Outlet />
        </Content>
      </Layout>
    </Layout >
  );
};
export default MainLayout;
